import React from "react";
import { connect } from "react-redux";
import { setDashboardParams } from "../../../../store/actions";

class DashboardOfficeSelector extends React.Component {
  handleOfficeSelection = (ev) => {
    ev.preventDefault();
    this.props.setSelectedOffice(+ev.target.value);
  };

  render() {
    return (
      <div>
        <div className="box-select-wrapper">
          <select
            className="box-selector"
            onChange={this.handleOfficeSelection}
            disabled={this.props.isloading === true}
            value={this.props.selectedOffice}
          >
            <option key="0" value={0}>
              Full Campaign
            </option>
            {(this.props.offices || []).map((office) => (
              <option key={office.id} value={office.id}>
                {office.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedOffice: state.dashboardParams.selectedOffice,
  offices:
    state.aggregates.offices && Array.isArray(state.aggregates.offices.rows)
      ? state.aggregates.offices.rows
      : state.offices.data, // condition to support legacy
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedOffice: (id) =>
    dispatch(
      setDashboardParams({
        selectedOffice: id,
        selectedRoute: 0,
        selectedShift: 0,
      })
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardOfficeSelector);
